import { render, staticRenderFns } from "./ChatFiles.vue?vue&type=template&id=dc233328&"
import script from "./ChatFiles.vue?vue&type=script&lang=js&"
export * from "./ChatFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports